import React from 'react'
import Muzaqi from '../Component/Muzaki/Muzaqi'
import Copyright from '../Component/Homepage/Copyright'
import Footer from '../Component/Homepage/Footer'
import Header from '../Component/Homepage/Header'

function Muzaki() {
  return (
    <>
    <Header/>
    <Muzaqi/>
    <Footer/>
    <Copyright/>
    </>
  )
}

export default Muzaki